var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRightFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow Right Filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x8E\xA8 Color",
    d: "M9.13636 2.85585C8.87409 2.59743 8.45199 2.60056 8.19357 2.86283C7.93516 3.1251 7.93829 3.5472 8.20056 3.80561L11.7808 7.33321H2.66667C2.29848 7.33321 2 7.63169 2 7.99988C2 8.36807 2.29848 8.66654 2.66667 8.66654H11.7764L8.20056 12.1898C7.93829 12.4482 7.93516 12.8703 8.19357 13.1326C8.45199 13.3949 8.87409 13.398 9.13636 13.1396L13.7525 8.59131C14.0838 8.2649 14.0838 7.73051 13.7525 7.4041L9.13636 2.85585Z",
    fill: "#9B9DAA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightFilled);
export default __webpack_public_path__ + "static/media/arrow-right-filled.d6d8c4ffee8e9b630d805c512f24f0b2.svg";
export { ForwardRef as ReactComponent };